import { httpBus } from "@/api/index.js";

/**
 * 数据分析/温度热管理/热管理分析
 * @param {*} param0
 * @returns
 */
export function heatManageAnalysis({ startTime, endTime, stationId, eBlockId }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/queryTempratureFromTAOS`, {
    params: {
      startTime,
      endTime,
      stationId: String(stationId),
      equipmentUUID: eBlockId
    },
  });
}



/**
 * 数据分析/温度热管理/热管理分析
 * @param {*} param0
 * @returns
 */
export function fetchPowerTrackingData({ startTime, endTime, stationId, isAllElink, isAllEblock, elinkIdArr, eblockIdArr }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/powerTracking/querySocAndPower`, {
    params: {
      startTime,
      endTime,
      stationId: String(stationId),
      allElink: Boolean(isAllElink),
      allEblock: Boolean(isAllEblock),
      elinkIDs: elinkIdArr.join(","),
      eblockIDs: eblockIdArr.join(","),
    },
  });
}



/**
 * 数据分析/温度热管理/电芯温度变化趋势曲线
 * @param {*} param0
 * @returns
 */
export function queryBatteryTemperature({ startTime, endTime, stationId, eBlockId }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/temperature/battery`, {
    params: {
      startTime,
      endTime,
      stationId: String(stationId),
      equipmentUUID: eBlockId
    },
  });
}



/**
 * 数据分析/温度热管理/PACK电芯温度变化趋势
 * @param {*} param0
 * @returns
 */
export function packTemperature({ startTime, endTime, stationId, eBlockId, packIndex }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/temperature/pack`, {
    params: {
      startTime,
      endTime,
      stationId: String(stationId),
      equipmentUUID: eBlockId,
      packNumber: packIndex
    },
  });
}



/**
 * 数据分析/温度热管理/pcs温度曲线
 * @param {*} param0
 * @returns
 */
export function pcsTemperature({ startTime, endTime, stationId, eBlockId }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/temperature/pcs`, {
    params: {
      startTime,
      endTime,
      stationId: String(stationId),
      equipmentUUID: eBlockId
    },
  });
}


/**
 * 数据分析/温度热管理/母排温度正负极历史曲线
 * @param {*} param0
 * @returns
 */
export function queryPackBusbarTempratureFromTAOS({ startTime, endTime, stationId, eBlockId }) {
  return httpBus.request("get", `/dashboard/dataAnalysis/queryPackBusbarTempratureFromTAOS`, {
    params: {
      startTime,
      endTime,
      stationId: String(stationId),
      equipmentUUID: eBlockId
    },
  });
}


